import isEqual from 'lodash/isEqual';
import React from 'react';
import { useSelector } from 'react-redux';

import { Hierarchy } from 'common/visualizations/vif';
import { getTableHierarchies } from 'common/authoring_workflow/selectors/vifAuthoring';
import { AuthoringWorkflowState } from 'common/authoring_workflow/reducers/types';
import AddHierarchyLink from './components/AddHierarchyLink';
import { TableHierarchyGroupings } from '../TableHierarchyGroupings';
import { isTableAdvancedTotalingEnabled } from 'common/visualizations/helpers/VifSelectors';

export const TableHierarchySelector = (): JSX.Element => {
  const tableHierarchies: Hierarchy[] = useSelector((state: AuthoringWorkflowState) => {
    return getTableHierarchies(state.vifAuthoring);
  }, isEqual);

  // INFO: EN-85363 remove line below and ensure we are using the new UI once advanced totaling is set to true permanently.
  // If advanced totaling feature flag has 'false' value, we will use the legacy design.
  return (
    <div
      className={`${isTableAdvancedTotalingEnabled() ? 'table-hierarchies-container ' : 'table-hierarchies-container--legacy'}`}
    >
      {tableHierarchies.map((h, idx: number) => (
        <TableHierarchyGroupings key={h.id} hierarchyIndex={idx} />
      ))}
      <div className="add-table-hierarchy-button">
        <AddHierarchyLink />
      </div>
    </div>
  );
};

export default TableHierarchySelector;
